import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-driver-score-wrapper',
  templateUrl: './driver-score-wrapper.component.html',
  styleUrls: ['./driver-score-wrapper.component.css']
})
export class DriverScoreWrapperComponent implements OnInit {

subMenu = 'score';
  isInspectionDot = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
  }

  ngOnInit() {
    
  }

  onSelectSubMenu(menu) {
    this.subMenu = menu;
    if (this.subMenu === 'score') {
      this.isInspectionDot = false;
    }
  }
}
